import React, { useEffect, useState } from 'react'
import LoginMobileHeader from '../../components/header/LoginMobileHeader';
import LoginHeader from '../../components/header/LoginHeader';
import Banner01 from '../../components/banner/Banner01';
import Job03 from '../../components/jobs/Job03';
import Category from "../../components/category";
import Box07 from '../../components/boxicon/Box07';
import Couter from "../../components/iconbox/Couter";
import Employer from '../../components/employer';
import Blog01 from '../../components/blog/Blog01';
import Partner from '../../components/partner';
import Footer from '../../components/footer';
import Gotop from '../../components/gotop';
import dataPartner from '../../assets/fakeData/dataPartner';
import dataBlog from '../../assets/fakeData/dataBlog';
import dataEm from '../../assets/fakeData/dataEmployers';
import dataCate from '../../assets/fakeData/dataCategory';
import InstituteHeader from '../../components/header/InstituteHeader';
import InstituteMobileHeader from '../../components/header/InstituteMobileHeader';
import TopCandidates from '../TopCandidates/TopCandidates';
import { Helmet } from 'react-helmet';
import ReviewJob10 from '../../components/jobs/ReviewJob10';
import Job05 from '../../components/jobs/Job05';
import dataJobs from '../../assets/fakeData/dataJobs';

const Institutehome = () => {
  const [isShowMobile, setShowMobile] = useState(false);
  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  return (
    <>
    <Helmet>
				<title>Home | Jobkikhoj</title>
				<meta name="description" content=" " />
				<meta name="keywords" content=" " />
				<meta property="og:title" content=" Home | Jobkikhoj" />
				<meta property="og:description" content="" />
				<meta property="og:url" content="https://jobkikhoj.com" />
			</Helmet>
      <InstituteMobileHeader handleMobile={handleMobile} />
      <InstituteHeader clname="act1" handleMobile={handleMobile} />
      <div className="pt-70">
        <Banner01 />
        {/* <Category data={dataCate}  title= "Browse by category"  text= "Recruitment Made Easy in 100 seconds"/> */}
        {/* <Job03  className="jobs-section" /> */}
        <Box07 />
        <ReviewJob10 /> 
        
        <div className="container">
          <Couter className="background1" />
        </div>

        <Job03 className="jobs-section" />

        {/* <Employer data={dataEm} className="employer-section-two" />  */}
        {/* <Blog01 data={dataBlog} className="news-section" /> */}
        <Partner data={dataPartner} />
        <Footer />
        <Gotop />
      </div>
    </>
  )

}

export default Institutehome